import apolloProvider from './apolloProvider'
import { map as _map } from 'lodash-es'

function preloadMany({mountedVm, queries, callback}) {
  const _queryMapFunction = ({skip, queryName, ...thisQuery}) => {
    if (skip) {
      return { successQuery: null, error: null }
    } else {
      let result = preload({
        onSuccess: () => {
          return { successQuery: thisQuery, error: null, queryName: queryName }
        },
        onError: (error) => {
          console.warn("Cardstock: PreloadMany query " + queryName + " errored")
          return { successQuery: null, error: error, queryName: queryName }
        },
        ...thisQuery
      })
      return result
    }
  }

  const _andThen = (results, callback, mountedVm) => {
    if (mountedVm) {
      callback(
        _map(results, ({successQuery, error, queryName}) => {
          if (error) {
            let narrative
        
            if (queryName) {
              narrative = queryName + ': '
            } else {
              narrative = ''
            }
          
            mountedVm.$emit('preload-error', narrative + error)
          }
        })
      )
    } else if (callback) {
      callback((vm) => {
        _map(results, ({successQuery, error, queryName}) => {
          if (error) {
            let narrative
        
            if (queryName) {
              narrative = queryName + ': '
            } else {
              narrative = ''
            }
          
            vm.$emit('preload-error', narrative + error)
          }
        })
      })
    }
  }

  Promise
    .all(_map(queries, _queryMapFunction))
    .then((results) => { _andThen(results, callback, mountedVm) })
}

function preload({mountedVm, onSuccess, onError, callback, queryName, ...query}) {
  const defaultOnSuccess = () => { callback() }

  const defaultOnError = (error) => {
    console.warn("Cardstock: Preload query " + queryName + " errored")
    let narrative

    if (queryName) {
      narrative = queryName + ': '
    } else {
      narrative = ''
    }
    
    if (mountedVm && callback) {
      callback(mountedVm.$emit('preload-error', narrative + error))
    } else if (callback) {
      callback( (vm) => {
        vm.$emit('preload-error', narrative + error)
      })
    }
  }

  return apolloProvider
    .defaultClient
    .query(query)
    .then(onSuccess || defaultOnSuccess)
    .catch(onError || defaultOnError)
}

export {
  preload,
  preloadMany
}
